export interface ErrorInfo {
  message: string
  statusCode: number | null
  isAuthError: boolean
  isPageError: boolean
}

export function analyzeError(err: any): ErrorInfo {
  const errorMessage = err instanceof Error ? err.message : 'Unknown error occurred'
  const statusCode = err.statusCode || err.status || null

  // Authorization failures
  const isAuthError = statusCode === 401 || statusCode === 403 ||
    (err instanceof Error && (
      err.message.includes('No access token') ||
      err.message.includes('Invalid token') ||
      err.message.includes('Token expired') ||
      err.message.includes('Unauthorized') ||
      err.message.includes('Forbidden')
    ))

  // Failures that take out the whole page
  const isPageError = isAuthError ||
    statusCode >= 500 ||
    statusCode === 404 ||
    (err instanceof Error && (
      err.message.includes('Network') ||
      err.message.includes('Failed to fetch')
    ))

  // Trim the message down to something readable
  let simplifiedMessage = errorMessage
  if (statusCode === 404) {
    simplifiedMessage = 'Resource not found'
  } else if (statusCode === 500) {
    simplifiedMessage = 'Server error'
  } else if (statusCode === 401) {
    simplifiedMessage = 'Authentication required'
  } else if (statusCode === 403) {
    simplifiedMessage = 'Access denied'
  } else if (errorMessage.includes('HTTP error! status:')) {
    simplifiedMessage = `Error ${statusCode}`
  }

  return {
    message: simplifiedMessage,
    statusCode: isAuthError ? (statusCode || 401) : statusCode,
    isAuthError,
    isPageError
  }
}